import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import { sendPasswordResetEmail } from "firebase/auth";
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";

function Forgot() {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    const handleReset = async (e) => {
        e.preventDefault();
        
        try {
            await sendPasswordResetEmail(auth, email);
            navigate("/login", { state: {email}});
        }

        catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message,
                confirmButtonColor: "#3085d6",
            });
        }
    }

    return (
        <div className="password-popup">
            <div className="main-page">
                <div className="dashboard"></div>
            </div>

            <div className="auth-container">
                <h1>Reset Password</h1>
                <form className="auth-form" onSubmit={handleReset} name="reset-password-form">
                <p style={{fontSize: "11px", marginTop:"-5px", color: "black"}}>You will be sent instructions to reset password for the email provided</p>
                    <TextField type="email" value={email} placeholder="Confirm Email" onChange={(e) => setEmail(e.target.value)} required size="small" sx={{
                        "& .MuiInputLabel-root.Mui-focused": { color: "black" }, "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { border: "1px solid black", color: "black"},},}}/>
                
                    <button type="submit" className="auth-btn">Reset Password</button>
                </form>
                <br/>
                <Link className="forgot-link" to="/">Back to Login</Link>
            </div>
        </div>
    );
}

export default Forgot;